import React, { useState } from 'react';
import './ImageWithLoader.css'; // Importa los estilos

const ImageWithLoader = ({ src, alt, placeholder, loader, ...props }) => {
  const [isLoading, setIsLoading] = useState(true); // Estado para controlar si la imagen se está cargando

  const handleImageLoad = () => {
    setIsLoading(false); // Una vez que la imagen se cargue, desactivamos el loader
  };

  return (
    <div className="image-container-withloader">
      {isLoading && (
        loader ? (
          <div className="loader">{loader}</div> // Si se pasa un loader personalizado
        ) : (
          <img src={placeholder} alt="placeholder" className="placeholder-image" /> // Placeholder por defecto
        )
      )}

      <img
        src={src}
        alt={alt}
        onLoad={handleImageLoad} // Llama al método cuando la imagen se carga
        className={`main-image ${isLoading ? 'hidden' : ''}`} // Oculta la imagen mientras carga
        {...props}
      />
    </div>
  );
};

export default ImageWithLoader;